import { render, staticRenderFns } from "./confirmMatch.vue?vue&type=template&id=6d71da6c&scoped=true"
import script from "./confirmMatch.vue?vue&type=script&lang=js"
export * from "./confirmMatch.vue?vue&type=script&lang=js"
import style0 from "./confirmMatch.vue?vue&type=style&index=0&id=6d71da6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d71da6c",
  null
  
)

export default component.exports